import { number, object, ObjectSchema, string, InferType } from "yup";

export const flightSchema = object()
  .shape({
    passengers: object({
      adult: number().required().default(1),
      child: number().default(0),
      infant: number().default(0),
    }),
    flightType: string()
      .oneOf(
        ["one-way", "round-trip"],
        "نوع پرواز باید یکی از 'one-way' یا 'round-trip' باشد"
      )
      .required("نوع پرواز الزامی می باشد"),
    date: object({
      depart: string(),
      return: string(),
    })
      .default(undefined)
      .when("flightType", {
        is: (val: "one-way" | "round-trip") => val === "one-way",
        then: (schema) =>
          schema.default(undefined).required("تاریخ رفت الزامی می باشد"),
        otherwise: (schema) =>
          schema
            .default(undefined)
            .required("تاریخ رفت و برگشت الزامی می باشد"),
      }),
    origin: object({
      name: string(),
      code: string(),
      id: number(),
      type: string().oneOf(["city", "airport"]),
    })
      .default(undefined)
      .required("مبدا الزامی می باشد"),
    destination: object({
      name: string(),
      code: string(),
      id: number(),
      type: string().oneOf(["city", "airport"]),
    })
      .default(undefined)
      .required("مقصد الزامی می باشد"),
  })
  .test(
    "origin-destination-different",
    "مبدا و مقصد نمی توانند یکسان باشند",
    function (value) {
      const { origin, destination } = value;
      if (origin && destination && origin.name === destination.name) {
        return this.createError({
          path: "destination",
          message: "مبدا و مقصد نمی توانند یکسان باشند",
        });
      }
      return true;
    }
  );

export const flightCalendarSchema = new ObjectSchema({
  origin_id: number().required(""),
  destination_id: number().required(""),
  date: string().required(""),
});

export type FlightSchema = typeof flightSchema;

export type FlightSchemaType = InferType<typeof flightSchema>;
